import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCalenderToday: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"calender-today"} maskId="square-filled-radius-0-stroke-1-IconCalenderToday"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM20 8H4V20H20V8ZM9.5 14C9.5 12.6193 10.6193 11.5 12 11.5C13.3807 11.5 14.5 12.6193 14.5 14C14.5 15.3807 13.3807 16.5 12 16.5C10.6193 16.5 9.5 15.3807 9.5 14Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCalenderToday;
